import productTile from './product/productTile';
import quickViewPdp from './product/quickViewPdp';
import search from './search/search';
import pagedesignerCustom from './search/pagedesignerCustom';
import sizeGuide from './product/sizeGuide';

var processInclude = require('base/util');

// eslint-disable-next-line no-undef
$(document).ready(function () {
    processInclude(search);
    processInclude(quickViewPdp);
    processInclude(productTile);
    processInclude(pagedesignerCustom);
    processInclude(sizeGuide);
});
